import React from 'react';
import { Bot, User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { usd } from './HeadlineStrip';

const mins = (m) => {
  if (m == null) return '—';
  if (m < 1) return '< 1 min';
  if (m < 60) return `${Math.round(m)} min`;
  if (m < 60 * 24) return `${(m / 60).toFixed(1)} h`;
  return `${(m / 60 / 24).toFixed(1)} days`;
};

export function ComparisonTable({ report }) {
  const { leo, human } = report;
  const rows = [
    { label: 'Total cost for this period (pay-per-hour)', leo: usd(leo.cost_usd, 2), human: usd(human.cost_usd, 2), win: leo.cost_usd <= human.cost_usd },
    { label: `Full-time hire cost (${human.heads_needed ?? 0} SDR${(human.heads_needed ?? 0) === 1 ? '' : 's'})`, leo: usd(leo.cost_usd, 2), human: usd(human.cost_usd_fixed, 2), win: (leo.cost_usd ?? 0) <= (human.cost_usd_fixed ?? Infinity) },
    { label: 'Cost per live conversation', leo: usd(leo.cost_per_conversation, 2), human: usd(human.cost_per_conversation, 2), win: (leo.cost_per_conversation ?? Infinity) <= (human.cost_per_conversation ?? Infinity) },
    { label: 'Cost per meeting booked', leo: usd(leo.cost_per_meeting, 2), human: usd(human.cost_per_meeting, 2), win: (leo.cost_per_meeting ?? Infinity) <= (human.cost_per_meeting ?? Infinity) },
    { label: 'Cost per outbound touch', leo: usd(leo.cost_per_touch, 2), human: usd(human.cost_per_touch, 2), win: (leo.cost_per_touch ?? Infinity) <= (human.cost_per_touch ?? Infinity) },
    { label: 'Hours of SDR work delivered', leo: `${leo.hours_worked} h`, human: `${human.hours_needed} h needed`, win: true },
    { label: 'Headcount required', leo: '0', human: `${human.fte_needed} FTE`, win: true },
    { label: 'Speed to first touch (median)', leo: mins(leo.speed_to_first_touch_minutes), human: mins(human.speed_to_first_touch_minutes), win: leo.speed_to_first_touch_minutes != null },
    { label: 'Availability', leo: leo.availability, human: human.availability, win: true },
  ];
  return (
    <Card data-testid="leo-impact-comparison">
      <CardHeader className="pb-3">
        <CardTitle className="text-base md:text-lg">Side by side — same work, two ways</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="grid grid-cols-12 px-5 py-2 text-[11px] uppercase tracking-wide text-muted-foreground border-b bg-muted/40">
          <div className="col-span-6">Metric</div>
          <div className="col-span-3 flex items-center gap-1 text-emerald-700"><Bot className="h-3.5 w-3.5" /> LEO (AI)</div>
          <div className="col-span-3 flex items-center gap-1"><User className="h-3.5 w-3.5" /> Human SDR</div>
        </div>
        {rows.map((r, i) => (
          <div key={r.label} className="grid grid-cols-12 px-5 py-3 border-b last:border-0 text-sm items-center" data-testid={`leo-impact-row-${i}`}>
            <div className="col-span-6 text-muted-foreground">{r.label}</div>
            <div className={`col-span-3 font-semibold tabular-nums ${r.win ? 'text-emerald-700 dark:text-emerald-400' : ''}`}>{r.leo}</div>
            <div className="col-span-3 tabular-nums">{r.human}</div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
